import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { AppSharedModule } from 'app/shared/app-shared.module';
import { BaseDialog } from 'app/shared/dialogs/base/base.dialog';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { UserPreferencesService } from 'app/shared/services/app/user-preferences.service';
import { ButtonModule } from 'primeng/button';
import { Dialog, DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { Router } from '@angular/router';

@Component({
  selector: 'miradi-subscription-nudge-dialog',
  templateUrl: './subscription-nudge.dialog.html',
  styleUrls: ['./subscription-nudge.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AppSharedModule,
    ButtonModule,
    DialogModule,
    MessageModule,
  ],
})
export class SubscriptionNudgeDialog extends BaseDialog {

  @ViewChild(Dialog, { static: true }) dialog: Dialog;

  showPricingPageLink: boolean;
  showSubscriptionStatusButton: boolean;

  constructor(
    authService: AuthService,
    cdr: ChangeDetectorRef,
    el: ElementRef,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
  ) {
    super(authService, cdr, el);
  }

  init(data: any): void {
    this.refresh();
  }

  refresh() {
    this.showPricingPageLink = window.location.href.indexOf('/subscriptions') < 0;
    this.showSubscriptionStatusButton = window.location.href.indexOf('/account') < 0;
    this.cdr.markForCheck();
  }

  persistAndDismiss(navigateTo?: '/subscriptions' | '/account' | null): void {
    // Update user preferences with current date
    const currentDate = new Date().toISOString();
    this.userPreferencesService.update('nudgeBannerLastDismissedDateTime', currentDate)
    .subscribe({
      next: () => {
        this.dismiss();
        if (navigateTo) {
          this.router.navigate([navigateTo]);
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        // console.error(error);
      }
    });
  }

}
